// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__3sby5","image":"styles_image__RtHIR","message":"styles_message__Kb7Wk","importCount":"styles_importCount__ZT3kq"};